<template>
  <!--  v-on="$listeners"-->
    <el-select
      v-if="computedIsEdit"
      v-model="scope.value"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      v-bind="$attrs"
      @clear="$emit('clear')"
    >
      <template v-for="(option,i) in dictListInner"><!-- 对象list形式的数据 -->
        <el-option
          :key="i"
          :value="getCode(option)"
          :label="$t(getLabel(option,i))"
          :disabled="option.disabled"
        />
      </template>
      <slot/>
    </el-select>
    <span v-else>
    <template v-if="multiple">
      <div v-for="(subVal,i) in scope.value" :key="i" class="subValue">{{ getLabel(dictMap[subVal], null) }} </div>
    </template>
    <template v-else>{{ getLabel(dictMap[scope.value], null) }}</template>
  </span>
</template>

<script>
import MixinScope from '../../main/js/mixin/MixinScope'
import MixinDiv from '../../main/js/mixin/MixinDiv'
import CollUtil from '../../main/js/utils/CollUtil'
import ObjectUtil from '../../main/js/utils/ObjectUtil'

/**
 * 快捷的el-select选择框
 */
export default {
  name: 'Zselect',
  mixins: [MixinScope, MixinDiv],
  props: {
    /**
     * 字典类名simpleClassName    v-model不能传boolean
     */
    multiple: {type: Boolean, default: false},
    isEdit: {type: Boolean, default: null},
    classname: {type: String},
    entityName: {type: String},
    filterable: {type: Boolean, default: true},
    clearable: {type: Boolean, default: true},
    defaultFirst: {type: Boolean, default: null},
    // notExistReturnValue: {type: Boolean, default: false},
    param: {}, // 额外参数,用于触发事件时的额外信息 例如表格中的 scope.row
    dictList: {},
    listCode: {default: 'code'},
    listLabel: {default: 'label'},
    nullToEmptyStr: {default: false},
    filter: {
      type: Function, default(obj) {
        return true
      }
    },
    codeFun: {
      type: Function, default(obj) {
        return null
      }
    },
    labelFun: {
      type: Function, default(obj) {
        return null
      }
    }
  },
  data() {
    return {
      init: false,
      dictListInner: [],
      dictMap: {},
      selectOptions: [],
    }
  },
  computed: {
    listLength() {
      return this.dictListInner.length
    }
  },
  watch: {
    dictList(newVal) {
      this.dictListInner = newVal
      this.dictListChange()
    },
    'scope.value': {
      handler(newValIn, oldVal) {
        // if (this.multiple && newValIn) {
        //   if (!Array.isArray(newValIn)) {
        //     newValIn = [newValIn]
        //   }
        // }
        const inToOut = this.$inToOutFun(newValIn)
        this.$emit('change', inToOut)
        // console.log('newValIn', newValIn)
        const option = this.multiple ? (newValIn && newValIn.map(subVal => this.dictMap[subVal])) : this.dictMap[newValIn]
        this.$emit('selectOption', option)
        // debugger
        // console.log('selectOption' + ' ' + inToOut+ ' ' + newValIn + ' ' + oldVal)
        if (this.init) {
          // this.$emit('input', inToOut) v-model默认会激活input事件?
        }
      },
      immediate: true,
      deep: true
    },
  },
  async created() {
    await this.reload()
    this.init = true
  },
  methods: {
    async reload() {
      // if (this.init) {
      //   debugger
      // }
      this.dictListInner = this.dictList || []
      // if (!this.listLength) {
      //   // 取系统枚举信息
      //   const map = ObjectUtil.readProp(this.$store.state.common.dictEnumMapAll, this.classname) || {}
      //   this.dictListInner = Object.keys(map).map(key => {
      //     const obj = {}
      //     obj[this.listCode] = key
      //     obj[this.listLabel] = map[key]
      //     return obj
      //   })
      // }
      if (this.entityName) {
        // protected long size = 10;
        // protected long current = 1;
        const list = (await this.$store.dispatch('common/dictListComputeIfAbsent', this.entityName)) || []
        list.forEach(o => {
          o.label = o.label || o.name
        })
        this.dictListInner = list
      }
      if (!this.listLength && this.classname) {
        this.dictListInner = (await this.$store.dispatch('common/dictListComputeIfAbsentEnum', this.classname)) || []
      }
      this.dictListChange()
    },
    dictListChange() {
      // const outKey = this.value
      // this.$nextTick(() => {
      this.dictListInner = this.dictListInner.filter(this.filter)
      this.dictMap = CollUtil.listToMapFun(this.dictListInner, this.getCode)
      if (ObjectUtil.isEmpty(this.value) && this.listLength && (this.defaultFirst || (this.defaultFirst == null && this.listLength === 1))) {
        // console.log('defaultFirst', this.defaultFirst)
        this.scope.value = this.getCode(this.dictListInner[0])
        // this.selectOptions = [this.dictListInner[0]]
        // this.$emit('selectOption', this.selectOptions)
      }
      // })
    },
    getCode(option) {
      return option && (this.codeFun(option) || option[this.listCode])
    },
    getLabel(option, index) {
      return option && (this.labelFun({...option, $index: index}) || option[this.listLabel])
    },
    $inToOutFun(inside){
      if (this.nullToEmptyStr && (null === inside || undefined === inside)) {
        return ''
      }
      return inside
    },
  }
}
</script>
<style scoped>
</style>

